import React from "react";
import {
  Radio,
  FormControl,
  RadioGroup,
  FormLabel,
  FormControlLabel,
} from "@material-ui/core";


function Nationality(props) {
    
    return (
        <FormControl>
            <FormLabel >내외국인</FormLabel>
            <RadioGroup
                row
                aria-label="InOutGb"
                name="InOutGb"
                variant="filled"
                value={props.InOutGb }
                onChange={(e) => {
                    console.log(e.target.value);
                    props.onChangeInOutGb(e.target.value)}}
            >
        <FormControlLabel  disabled={props.SelfCertification} value="1" control={<Radio />} label="내국인" />
        <FormControlLabel  disabled={props.SelfCertification} value="2" control={<Radio />} label="외국인" />
      </RadioGroup>
    </FormControl>
      );
}

export default Nationality;